import {
    Button,
    Collapse,
    Divider,
    Drawer,
    IconButton,
    Paper,
    Typography,
    styled,
} from "@mui/material";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { closeAlerts } from "../../reducers/common";
import { Close } from "@mui/icons-material";
import AlertsList from "./AlertsList";
import { hexToRgb } from "./utils/utils";

const StyledCollapse = styled(Collapse)(() => ({
    position: "sticky",
    top: 0,
    bottom: 0,
    height: 0,
}));

const StyledPaper = styled(Paper, {
    shouldForwardProp: (prop) =>
        !["drawerWidth", "sidebarOpen"].includes(prop.toString()),
})<{
    drawerWidth: number;
    sidebarOpen: boolean;
}>(({ theme, drawerWidth, sidebarOpen }) => ({
    position: "relative",
    height: "100vh",
    background: "#F5F5F7",
    color: theme.palette.primary.main,
    paddingTop: "32px",
    border: "none",
    width: "500px",
    maxHeight: "100vh",
    borderRadius: "0px",
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    position: "absolute",
    top: "8px",
    right: "8px",
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
    borderColor: `rgba(${hexToRgb(
        theme.palette.secondary.main,
        "string"
    )}, 0.5)`,
}));

type Props = {
    drawerWidth: number;
};

const AlertsDrawer = ({ drawerWidth }: Props) => {
    const dispatch = useAppDispatch();
    const { alertsOpen, sidebarOpen } = useAppSelector((state) => state.common);
    const { alerts, alertsLoading } = useAppSelector((state) => state.config);

    return (
        <StyledCollapse
            in={alertsOpen}
            orientation="horizontal"
            timeout={0}
            sx={{
                zIndex: 1000,
                left: sidebarOpen ? drawerWidth : `57px`,
            }}
        >
            <StyledPaper drawerWidth={drawerWidth} sidebarOpen={sidebarOpen}>
                <StyledIconButton
                    color="primary"
                    onClick={() => dispatch(closeAlerts())}
                >
                    <Close />
                </StyledIconButton>
                <Typography
                    variant="h4"
                    color="primary"
                    fontWeight="bold"
                    marginLeft="36px"
                    marginBottom="4px"
                >
                    Alerts
                </Typography>
                <Typography
                    variant="body2"
                    color="primary"
                    marginLeft="36px"
                    marginBottom="24px"
                >
                    {alertsLoading
                        ? "Loading..."
                        : alerts.length === 0
                        ? "You're all set!"
                        : `You have ${alerts.length} alert${
                              alerts.length > 1 ? "s" : ""
                          }`}
                </Typography>
                <StyledDivider />
                <AlertsList />
            </StyledPaper>
        </StyledCollapse>
    );
};

export default AlertsDrawer;
